import { EpimsBaseEntityDto } from './epim-base.dto';
export class SeismicSwathNoDto extends EpimsBaseEntityDto {
  SwathNo: string;
  SwathName: string;
  SwathDescription: string;
  BranchCode: string;
  SubscriptionUserId: string;
  Version: number;
}
